// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #F0F0F0;
}
#app {
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
#video {
    background-color: #000000;
}
#canvas {
    display: none;
}
li {
    display: inline;
    padding: 5px;
}


.smallCamera {
    display: flex;
    justify-content: flex-end;
}

.smallCamera > video{
    width: 180px;
    height: 100px;
    bottom: 90px;
    right: 10px;
    position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom/videoDisplayer/videoDisplayer.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;AACnB","sourcesContent":["body {\r\n    background-color: #F0F0F0;\r\n}\r\n#app {\r\n    text-align: center;\r\n    color: #2c3e50;\r\n    margin-top: 60px;\r\n}\r\n#video {\r\n    background-color: #000000;\r\n}\r\n#canvas {\r\n    display: none;\r\n}\r\nli {\r\n    display: inline;\r\n    padding: 5px;\r\n}\r\n\r\n\r\n.smallCamera {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.smallCamera > video{\r\n    width: 180px;\r\n    height: 100px;\r\n    bottom: 90px;\r\n    right: 10px;\r\n    position: fixed;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
